<div *ngIf="!isDeleteConfirmationVisible" class="part-matrix-item flex-start-end">
  <!-- Min Price -->
  <div class="b-bottom-gray-85 pt-2 pb-2 pricing-min flex-start-center cursor-default start font-13">
    <span class="pt-1 pb-1" [ngClass]="{'disabled': (isPricingManagementEnable && !isPricingMatricesManagement)}"
      tooltipStyleClass="pricing-management-tooltip"
      [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement) ? 'Please contact admin / store manager to update' : ''">{{pricing?.min
      | currency:
      usd}}</span>
  </div>

  <!-- Max Price -->
  <div class="end">
    <app-input id="price-matrix-item-price{{index}}" placeholder="$0.00" styleClass="pl-0 pt-2 pb-2"
      styleClassInput="pl-0 pt-1 pb-1" [fontSize]="13"
      [value]="focus?.max || !pricing.max? pricing?.max: pricing?.max | currency: usd"
      [allowDecimal]="focus?.max? true : false" [isInvalid]="error?.max" [selectTextOnFocus]="true"
      [disabled]="(isPricingManagementEnable && !isPricingMatricesManagement)" tooltipPosition="top"
      tooltipStyleClass="pricing-management-tooltip"
      [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement) ? 'Please contact admin / store manager to update' : ''"
      (appChange)="handleChange('max', $event)" (appFocus)="handleFocus('max')" (appBlur)="handleBlur('max')">
    </app-input>
  </div>

  <!-- Margin Price -->
  <div class="margin">
    <app-input id="price-matrix-item-margin{{index}}" placeholder="0.00%" styleClass="pl-0 pt-2 pb-2"
    styleClassInput="pl-0 pt-1 pb-1" [allowDecimal]="true"
    [value]="focus?.margin || !pricing.margin? pricing?.margin: pricing?.margin + '%'" [fontSize]="13"
    [isInvalid]="error?.margin" [selectTextOnFocus]="true" [mask]="focus?.margin ? 'percentage': ''"
    [disabled]="(isPricingManagementEnable && !isPricingMatricesManagement)" tooltipPosition="top"
    tooltipStyleClass="pricing-management-tooltip"
    [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement) ? 'Please contact admin / store manager to update' : ''"
    (appChange)="handleChange('margin', $event)" (appFocus)="handleFocus('margin')" (appBlur)="handleBlur('margin')">
  </app-input>
  </div>

  <!-- Markup Price -->
  <div class="markup">
    <app-input id="price-matrix-item-markup{{index}}" placeholder="0.00%" styleClass="pl-0 pt-2 pb-2"
      styleClassInput="pl-0 pt-1 pb-1" [allowDecimal]="true"
      [value]="focus?.markup || !pricing.markup? pricing?.markup: pricing?.markup + '%'" [fontSize]="13"
      [isInvalid]="error?.markup" [selectTextOnFocus]="true"
      [disabled]="(isPricingManagementEnable && !isPricingMatricesManagement)" tooltipPosition="top"
      tooltipStyleClass="pricing-management-tooltip"
      [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement) ? 'Please contact admin / store manager to update' : ''"
      (appChange)="handleChange('markup', $event)" (appFocus)="handleFocus('markup')" (appBlur)="handleBlur('markup')">
    </app-input>
  </div>

  <!-- Description -->
  <div class="b-bottom-gray-85 description pt-2 pb-2 pricing-desc flex-start-center">
    <p class="m-0 cursor-default text-truncate pr-2 pt-1 pb-1 font-13 d-block d-lg-none"
      [ngClass]="{'disabled': (isPricingManagementEnable && !isPricingMatricesManagement)}" (click)="showTooltip()"
      [life]="3000" tooltipEvent="focus" pTooltip="Price is {{salesPrice || 0 | currency: usd}} based on cost of {{pricing?.max || 0 | currency: usd}},
    {{pricing?.markup || 0 | currency: usd}}% markup with
    {{pricing?.margin || 0 | currency: usd}}% margin" tooltipPosition="top">
      Price is {{salesPrice || 0 | currency: usd}} based on cost of {{pricing?.max || 0 | currency: usd}},
      {{pricing?.markup || 0}}% markup with
      {{pricing?.margin || 0}}% margin
    </p>
    <p class="m-0 cursor-default text-truncate pr-2 pt-1 pb-1 font-13 d-none d-lg-block"
      [ngClass]="{'disabled': (isPricingManagementEnable && !isPricingMatricesManagement)}" pTooltip="Price is {{salesPrice || 0 | currency: usd}} based on cost of {{pricing?.max || 0 | currency: usd}},
    {{pricing?.markup || 0 | currency: usd}}% markup with
    {{pricing?.margin || 0 | currency: usd}}% margin" tooltipPosition="top">
      Price is {{salesPrice || 0 | currency: usd}} based on cost of {{pricing?.max || 0 | currency: usd}},
      {{pricing?.markup || 0}}% markup with
      {{pricing?.margin || 0}}% margin
    </p>
  </div>

  <!-- Delete -->
  <div class="b-bottom-gray-85 pt-2 pb-2 pricing-delete flex-center-center">
    <span class="pt-1 pb-1">
      <button [disabled]="(isPricingManagementEnable && !isPricingMatricesManagement) || isReadOnlyPricing" tooltipPosition="left"
        [pTooltip]="(isPricingManagementEnable && !isPricingMatricesManagement) ? 'Please contact admin / store manager to update' : 'Delete'"
        *ngIf="index && index !== (noOfItems - 1)" class="far fa-trash pointer font-gray-85"
        (click)="toggleConfirmDelete()"></button>
    </span>
  </div>
</div>

<div *ngIf="isDeleteConfirmationVisible" class="part-matrix-item b-bottom-gray-85 pb-1 pt-1 flex-between-end">
  <div class="flex-start-center">
    <div class="flex-column">
      <p class="m-0 font-13">Delete Range?</p>
      <p class="m-0 font-13">
        Deleting this range will merge it with the previous range
      </p>
    </div>
    <i class="far fa-level-up pl-2 font-16"></i>
  </div>

  <div class="action">
    <button class="btn btn-border font-12 mr-2 width-80" (click)="toggleConfirmDelete()">
      Cancel
    </button>
    <button class="btn btn-primary font-12 width-80" (click)="deletePricingItem()">
      Delete
    </button>
  </div>
</div>
